import React, { useEffect, useState } from "react";
import axios from "axios";
import AccountATMFormModal from "./AccountATMForm"; // Updated to modal version
import CustomNavbar from "../../CustomPermissions/CustomNavbar";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../../config/api";

const AccountATMList = () => {
  const [atms, setAtms] = useState([]);
  const [editingAtm, setEditingAtm] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Fetch all ATM records
  useEffect(() => {
    const fetchATMs = async () => {
      try {
        const accessToken = localStorage.getItem("access_token");
        const response = await axios.get(
          getApiUrl("/PartnerFiles/api/atms/"),
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );
        setAtms(response.data);
      } catch (error) {
        console.error("Error fetching ATMs:", error);
      }
    };
    fetchATMs();
  }, []);

  // Handle ATM deletion
  const handleDelete = async (id) => {
    try {
      const accessToken = localStorage.getItem("access_token");
      await axios.delete(getApiUrl(`/PartnerFiles/api/atms/${id}/`), {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      setAtms(atms.filter((atm) => atm.id !== id));
    } catch (error) {
      console.error("Error deleting ATM:", error);
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <CustomNavbar />
      <div
        className="p-3 bg-gradient-to-br from-blue-50 to-blue-200 min-h-screen"
        style={{ width: "100vw", margin: "0 auto" }}
      >
        {/* Title */}
        <h2 className="text-3xl font-bold text-blue-800 mb-3 text-center">
          ATM Records Management
        </h2>

        {/* Buttons to Open Modal */}
        <div className="flex justify-center mb-4">
          <button
            onClick={() => {
              setEditingAtm(null); // Reset editing state for new creation
              setIsModalOpen(true); // Open modal
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition duration-200"
          >
            Create New ATM
          </button>
        </div>

        {/* Table for listing ATMs */}
        <div
          className="overflow-x-auto rounded-lg "
          style={{ height: "100vh" }}
        >
          <table
            className="min-w-full bg-white border border-blue-300 divide-y divide-blue-300"
            style={{ width: "100%", margin: "auto" }}
          >
            <thead className="bg-blue-100">
              <tr className="bg-blue-500 text-white">
                <th className="px-4 py-3 text-left text-sm font-semibold uppercase tracking-wider">
                  ID
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold uppercase tracking-wider">
                  ATM Number
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold uppercase tracking-wider">
                  Expiry
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-blue-300">
              {atms.map((atm) => (
                <tr
                  key={atm.id}
                  className="hover:bg-blue-50 transition duration-200"
                >
                  <td className="px-4 py-3 text-sm text-blue-900">{atm.id}</td>
                  <td className="px-4 py-3 text-sm text-blue-900">
                    {atm.atm_number}
                  </td>
                  <td className="px-4 py-3 text-sm text-blue-900">
                    {atm.expiry}
                  </td>
                  <td className="px-4 py-3 text-sm text-blue-900 space-x-2">
                    <button
                      onClick={() => {
                        setEditingAtm(atm); // Set ATM for editing
                        setIsModalOpen(true); // Open modal
                      }}
                      className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition duration-200"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(atm.id)}
                      className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 transition duration-200"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Modal for Create/Edit Form */}
        {isModalOpen && (
          <AccountATMFormModal
            atms={atms}
            setAtms={setAtms}
            editingAtm={editingAtm}
            onClose={() => setIsModalOpen(false)} // Close modal
          />
        )}
      </div>
    </div>
  );
};

export default AccountATMList;
